import { createSlice } from '@reduxjs/toolkit';
import { updateProfile, getProfile } from '../../actions/profileActions';
import { actionTypes } from '../../actionTypes';
// redux state
const initialState = {
  profile: undefined,
  error: '',
  isLoading: false,
};

// slice or reducer
const Profile = createSlice({
  name: 'Profile',
  initialState,
  // normal reducers
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
  },
  // async reducers
  extraReducers: (builder) => {
    caseProfile(builder, getProfile);
    caseProfile(builder, updateProfile);
  },
});
export default Profile.reducer;

const caseProfile = (builder, action) => {
  builder.addCase(action.pending, (state) => {
    state.isLoading = true;
  });
  handleAllFulfillCases(builder, action);

  builder.addCase(action.rejected, (state) => {
    state.isLoading = false;
  });
};

const handleAllFulfillCases = (builder, action) => {
  builder.addCase(action.fulfilled, (state, action) => {
    // state updated in fulfilled state

    if (action.type.includes(actionTypes.GET_PROFILE)) {
      state.profile = action.payload;
      state.isLoading = false;
    } else if (action.type.includes(actionTypes.UPDATE_PROFILE)) {
      state.profile = action.payload;
      state.isLoading = false;
    }
  });
};
